// extracted by mini-css-extract-plugin
export default {"hasError":"ZEouXc"};